import { useQuery } from 'hooks/useCustomQuery';
import getAllTRSRegistrationsByCompanyId from 'API/TRSRegistration/getTRSRegistrationsByCompanyId';
import ScopeType from 'utils/enums/ScopeType';

/**
 * (3153) The company's TRS registrations. There is no flag for whether TRS
 * is enabled; a company without it gets an error back, which leaves the TRS
 * notification out.
 */
const useGetCompanyTrsRegistrations = (companyId, options = {}) =>
    useQuery({
        queryKey: ['dashboardHome', 'trsRegistrations', companyId],
        queryFn: async () =>
            (await getAllTRSRegistrationsByCompanyId(
                ScopeType.COMPANY,
                companyId,
            )) || [],
        enabled: !!companyId,
        refetchOnWindowFocus: false,
        retry: false,
        ...options,
    });

export default useGetCompanyTrsRegistrations;
